import { Injectable, Query } from '@angular/core';
import { QueryRef } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GQLThread } from '../../../../../schemas/schemas';
import { GET_THREAD } from '../../../graphQL/graphql-requests/queries';
import { BaseApi } from '../../../services/base-api';

@Injectable({
  providedIn: 'root',
})
export class ThreadsService {
  constructor(private readonly api: BaseApi) {}

  loadThread(id: string): Observable<GQLThread> {
    return this.api.apollo
      .watchQuery<QueryRef<Query>>({
        query: GET_THREAD,
        variables: { id },
        fetchPolicy: 'cache-and-network',
      })
      .valueChanges.pipe(
        map(({ data }: any) => {
          return data.thread;
        }),
      );
  }
}
